import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-green-200 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Information */}
          <div>
            <h3 className="text-2xl font-semibold mb-4 text-black">Edgecore Technologies</h3>
            <p className="text-lg mb-4 text-black">
              Leading IT recruitment, training, and placement services provider.
            </p>
            <p className="text-lg text-black">Your trusted partner in technology solutions.</p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-2xl font-semibold mb-4 text-black">Quick Links</h3>
            <ul className="space-y-2 text-black">
              <li>
                <Link to="/" className="hover:text-gray-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/service" className="hover:text-gray-200">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about-us" className="hover:text-gray-200">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contactus" className="hover:text-gray-200">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Media and Address */}
          <div className="flex flex-col gap-3">
            <h3 className="text-2xl font-semibold mb-4 text-black">Address</h3>
            <div className="text-black">
              EDGECORE TECHNOLOGIES LLP Company office Address: 113, SETHI NAGAR, LAL BAG, RTO CHOURAHA, Indore- 452002, Madhya Pradesh, India
            </div>
            <div className="text-black">
              Contact No.: <span className="text-black font-bold">+91-8109472820</span>
            </div>

            <div className="flex items-center gap-3">
              <div className="md:flex hidden p-4 items-center justify-between gap-2">
                <div className="flex items-center gap-3">
                  <label className="text-black">Follow Us on:</label>
                  <div className="flex gap-3 text-black">
                    {/* Facebook */}
                    <a href="https://www.facebook.com/yourpage" target="_blank" rel="noopener noreferrer">
                      <i className="fa fa-facebook-f"></i>
                    </a>

                    {/* Instagram */}
                    <a href="https://www.instagram.com/yourpage" target="_blank" rel="noopener noreferrer">
                      <i className="fa fa-instagram"></i>
                    </a>

                    {/* WhatsApp */}
                    <a href="https://wa.me/yourphonenumber" target="_blank" rel="noopener noreferrer">
                      <i className="fa fa-whatsapp"></i>
                    </a>

                    {/* LinkedIn */}
                    <a href="https://www.linkedin.com/in/yourprofile" target="_blank" rel="noopener noreferrer">
                      <i className="fa fa-linkedin"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-8 border-t pt-4 text-black">
          <p>&copy; 2024 Edgecore Technologies. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
